module.exports = __webpack_public_path__ + "img/identity.a4f791a0.svg";